import React, { useCallback, useState } from "react";

import { Grid } from "@mui/material";

import Header from "../common/header/Header";
import Content from "../content/Content";
import VerticalBar from "../vertical-bar/VerticalBar";
import SlideMenu from "../common/slide-menu/SlideMenu";

import "./layout.scss";

const Layout = () => {
    const [isSlideMenuOpen, setIsSlideMenuOpen] = useState(false);

    const openSlideMenu = useCallback(() => {
        setIsSlideMenuOpen(true);
    }, []);

    const closeSlideMenu = useCallback(() => {
        setIsSlideMenuOpen(false);
    }, []);

    return (
        <div className="layoutContainer">
            <Header openSlideMenu={openSlideMenu} />
            {isSlideMenuOpen ? (
                <SlideMenu closeSlideMenu={closeSlideMenu} />
            ) : null}
            <div className="flexContainer flexGrow of-auto">
                <Grid className="flexGrow" container columns={16}>
                    <Grid
                        className="fullSpace of-auto sidePanel"
                        item
                        xs={16}
                        sm={16}
                        md={2}
                    >
                        <VerticalBar />
                    </Grid>
                    <Grid className="fullSpace" item xs={16} sm={16} md={14}>
                        <Content />
                    </Grid>
                </Grid>
            </div>
        </div>
    );
};

export default Layout;
